import { useEffect } from "react";
import { Link } from "@tanstack/react-router";

const CREAM = "#FAF7F5";
const ESPRESSO = "#4B1F4F";
const GR = "#6E4B71";

export function TermlyPolicyPage({ dataId, title }: { dataId: string; title: string }) {
  useEffect(() => {
    const scriptId = "termly-jssdk";
    const w = window as any;
    if (document.getElementById(scriptId)) {
      if (w.Termly && typeof w.Termly.init === "function") {
        w.Termly.init();
      }
      return;
    }
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://app.termly.io/embed-policy.min.js";
    script.async = true;
    document.body.appendChild(script);
  }, [dataId]);

  return (
    <div style={{ minHeight: "100vh", background: CREAM, color: ESPRESSO, padding: "32px 20px 64px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <Link to="/" style={{ color: ESPRESSO, textDecoration: "none", fontSize: 14, opacity: 0.8 }}>
          ← Back to home
        </Link>
        <h1 style={{ marginTop: 24, marginBottom: 24, fontSize: 32, fontWeight: 600, letterSpacing: -0.5 }}>
          {title}
        </h1>
        <div
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: 24,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div {...({ name: "termly-embed" } as any)} data-id={dataId} />
        </div>

        <div
          style={{
            marginTop: 40,
            paddingTop: 20,
            borderTop: "0.5px solid #E8D5DA",
            display: "flex",
            justifyContent: "center",
            gap: 18,
            fontSize: 12,
            color: GR,
            flexWrap: "wrap",
          }}
        >
          <Link to="/privacy" style={{ color: GR, textDecoration: "none" }}>Privacy Policy</Link>
          <Link to="/terms" style={{ color: GR, textDecoration: "none" }}>Terms</Link>
          <Link to="/cookies" style={{ color: GR, textDecoration: "none" }}>Cookie Policy</Link>
          <Link to="/disclaimer" style={{ color: GR, textDecoration: "none" }}>Disclaimer</Link>
          <a
            href="#"
            style={{ color: GR, textDecoration: "none" }}
            onClick={(e) => {
              e.preventDefault();
              const w = window as any;
              if (typeof window !== "undefined" && w.displayPreferenceModal) {
                w.displayPreferenceModal();
              }
            }}
          >
            Cookie Preferences
          </a>
          <a href="mailto:hello@knowmeno.com" style={{ color: GR, textDecoration: "none" }}>Contact</a>
        </div>
      </div>
    </div>
  );
}
